import '../stylesheets/footer/footer.css'

export default function Footer(){
    return(
        <footer>
            <p>Made by SAVRE Kélian in 2024</p>
        </footer>
    )
}